import axiosInstance from '@api';
import { PhotoDto } from '@dto';

export const upload = (formData: FormData): Promise<PhotoDto> =>
  axiosInstance.post('/files/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
